import { render, staticRenderFns } from "./AllCourses.vue?vue&type=template&id=68e9a520&scoped=true"
import script from "./AllCourses.vue?vue&type=script&lang=js"
export * from "./AllCourses.vue?vue&type=script&lang=js"
import style0 from "./AllCourses.vue?vue&type=style&index=0&id=68e9a520&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e9a520",
  null
  
)

export default component.exports